import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { JobPositionsService } from "../../job-positions.service";
import { locale as jobPositionsIt } from "../../i18n/jobPositionsIt";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { IFigure } from "app/auth/models/figures";
import { IJobPosition } from "app/auth/models/jobs";

@Component({
  selector: "app-list",
  templateUrl: "./job-positions-list.component.html",
  styleUrls: ["./job-positions-list.component.scss"],
})
export class JobPositionsListComponent implements OnInit {
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public filterFigure: number = null;
  public contentHeader: IContentHeader;
  public jobPositionList: IJobPosition[] = [];
  public filteredJobPositionList: IJobPosition[] = [];
  public figuresList: IFigure[] = [];
  constructor(
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    public _jobPositionsService: JobPositionsService,
    public _figureListService: UserFigureService,
  ) {
    this.contentHeader = {
      headerTitle: jobPositionsIt.data.MENU.JOB_POSITIONS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: jobPositionsIt.data.MENU.JOB_POSITIONS,
            isLink: false,
          },
        ],
      },
    };
  }
  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_job_positions")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.figuresList = await this._figureListService.getList();
    await this.lodJobPositions();
  }

  async lodJobPositions() {
    this.jobPositionList = await this._jobPositionsService.getListJobPositions();
    this.filterList();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  filterList() {
    let items: IJobPosition[] = this.jobPositionList;
    const keywords: string = this.searchKeyword.trim();

    if (keywords.length > 0) {
      items = this.jobPositionList.filter((item: IJobPosition) => item.title.toLowerCase().includes(this.searchKeyword.toLowerCase()) || item?.city_name?.toLowerCase().includes(this.searchKeyword.toLowerCase()));
    }

    if (!!this.filterFigure) {
      items = this.jobPositionList.filter((item: IJobPosition) => item.figure_id === this.filterFigure);
    }

    this.filteredJobPositionList = items;
  }

  async delete(currentItem: { title: string; id?: number }) {
    if (!this._authenticationService.hasCapability("delete_job_position")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentItem.title;

    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        await this._jobPositionsService
          .deleteJobPosition(currentItem.id)
          .then(async () => {
            await this._utilService.showPopupItemDeleted().then(async () => {
              await this.lodJobPositions();
            });
          })
          .catch(() => this._utilService.showSWALError({ text: "ERROR_JOB_POSITION_REMOVE" }));
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }
}
